import React, { FunctionComponent } from 'react';

import { pageDate } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import { SeoCanonical } from 'lib/seo-canonical';

import PageSectionCards from 'components/page/sections/page-section-cards';

export const DateBlockOneContainer: FunctionComponent = () => {
  const props = {
    title: pageDate.lxPageDateTwoBlockTitle,
    items: [
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/feature-incognito.svg`,
        title: pageDate.lxPageDateTwoBlockTwoItemTitle,
        text: pageDate.lxPageDateTwoBlockTwoItemText,
        href: SeoCanonical.features_incognito_mode,
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/feature-compliments.svg`,
        title: pageDate.lxPageDateTwoBlockThreeItemTitle,
        text: pageDate.lxPageDateTwoBlockThreeItemText,
        href: SeoCanonical.features_compliments,
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/feature-video-calls.svg`,
        title: pageDate.lxPageDateTwoBlockFourItemTitle,
        text: pageDate.lxPageDateTwoBlockFourItemText,
        href: SeoCanonical.features_video_chat,
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/feature-snooze-mode.png`,
        title: pageDate.lxPageDateTwoBlockFiveItemTitle,
        text: pageDate.lxPageDateTwoBlockFiveItemText,
        href: SeoCanonical.features_snooze_mode,
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/feature-superswipe.svg`,
        title: pageDate.lxPageDateTwoBlockSixItemTitle,
        text: pageDate.lxPageDateTwoBlockSixItemText,
        href: SeoCanonical.features_superswipe,
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/feature-travel-mode.svg`,
        title: pageDate.lxPageDateTwoBlockSevenItemTitle,
        text: pageDate.lxPageDateTwoBlockSevenItemText,
        href: SeoCanonical.features_travel_mode,
      },
    ],
    showMoreAction: pageDate.lxPageDateTwoBlockOneItemShowMoreAction,
  };

  return <PageSectionCards title={props.title} cards={props.items} color="yellow" />;
};
